import { UI, FONT } from "../constants/tokens";
import LTR from "./LTR";

// ─── "למה זה רלוונטי לתיק שלי" ───────────────────────────────────────────────
// One factual line, the same one everywhere it is asked: which holdings this
// touches, how much of the portfolio they are, and whether the tie is the
// company itself or only its sector.
//
//   בתיק שלך: AAPL · 35.4% מהתיק
//   בתיק שלך: AAPL · MSFT · 63.4% מהתיק · אותו סקטור
//
// What it never says: "influences", "significant", "important to you", "worth
// watching". The weight is a measured number and the relation is a fact about
// a list; what a reader concludes from them is theirs to conclude. This is
// VISION's second question — "why is it relevant to my portfolio" — answered
// with data instead of with an adjective.
//
// Something only on the watchlist says so, because "בתיק שלך" about a company
// the user does not own would simply be false.
export default function PortfolioTie({ symbol, symbols, weight, relation = "direct", held = true, max = 3, style = {} }) {
  const list = (Array.isArray(symbols) ? symbols : [symbol]).filter(Boolean);
  if (!list.length) return null;
  const shown = list.slice(0, max);
  const rest  = list.length - shown.length;
  return (
    <div dir="auto" style={{
      display: "flex", alignItems: "baseline", flexWrap: "wrap", gap: 5,
      fontSize: 12.5, color: UI.text.secondary, ...style,
    }}>
      <span style={{ color: UI.text.muted }}>{held ? "בתיק שלך:" : "ברשימת המעקב:"}</span>
      {shown.map((sym, i) => (
        <span key={sym} style={{ display: "inline-flex", alignItems: "baseline", gap: 5 }}>
          {i > 0 && <span style={{ color: UI.text.muted }}>·</span>}
          <LTR style={{ fontFamily: FONT.latin, fontWeight: 700, color: UI.text.primary }}>{sym}</LTR>
        </span>
      ))}
      {rest > 0 && <span style={{ color: UI.text.muted }}>+<LTR className="si-num">{rest}</LTR></span>}
      {Number.isFinite(weight) && weight > 0 && (
        <>
          <span style={{ color: UI.text.muted }}>·</span>
          <LTR className="si-num">{weight.toFixed(1)}%</LTR>
          <span style={{ color: UI.text.muted }}>מהתיק</span>
        </>
      )}
      {relation === "sector" && (
        <>
          <span style={{ color: UI.text.muted }}>·</span>
          <span style={{ color: UI.text.muted }}>אותו סקטור</span>
        </>
      )}
    </div>
  );
}
